import script from "./TechSupportPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TechSupportPage.vue?vue&type=script&setup=true&lang=js"

import "./TechSupportPage.vue?vue&type=style&index=0&id=2ceaee6b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ceaee6b"]])

export default __exports__